import React, {Component} from 'react';
import './FileUpload.css';
import {Form,} from 'antd';
import 'react-datetime/css/react-datetime.css'
import Uploader from "../../components/Uploader/Uploader";
import {Label} from "reactstrap";

class FileUpload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fileInfo: {
                kimlikCuzdanFile: this.props.memberInfo.kimlikCuzdanFile,
                adliSicilFile: this.props.memberInfo.adliSicilFile,
                ruhsatnameFile: this.props.memberInfo.ruhsatnameFile,
                diplomaFile:this.props.memberInfo.diplomaFile,
                ikametgahFile: this.props.memberInfo.ikametgahFile,
                fotoFile:this.props.memberInfo.fotoFile,
                kimlikCuzdanFileName:"kimlikCuzdanFile",
                adliSicilFileName:"adliSicilFile",
                ruhsatnameFileName:"ruhsatnameFile",
                diplomaFileName: "diplomaFile",
                ikametgahFileName: "ikametgahFile",
                fotoFileName: "fotoFile",
            }
        };
        this.handleInfoChange_=this.handleInfoChange_.bind(this);
    }

    handleInfoChange_(name,value) {
        console.log("handleInfoChange_ name,value==>" ,name,value);
        this.props.onInfoChange(name,value);
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div className="fileUpload-container ">
                <Form>
                    <Label className="col-sm-3" >
                        Fotoğraf:
                    </Label>
                    <Uploader onInfoChange={this.handleInfoChange_}
                              fileName={this.state.fileInfo.fotoFileName} file={this.props.memberInfo.fotoFile} isDisabled={false}/>
                    <br/>
                    <Label className="col-sm-3" >
                        Nüfus Cüzdanı Sureti:
                    </Label>
                    <Uploader onInfoChange={this.handleInfoChange_}
                              fileName={this.state.fileInfo.kimlikCuzdanFileName} file={this.props.memberInfo.kimlikCuzdanFile} isDisabled={false}/>
                    <br/>
                    <Label className="col-sm-3" >
                        Adli Sicil Belgesi:
                    </Label>
                    <Uploader onInfoChange={this.handleInfoChange_}
                              fileName={this.state.fileInfo.adliSicilFileName} file={this.props.memberInfo.adliSicilFile} isDisabled={false}/>
                    <br/>
                    <Label className="col-sm-3" >
                        Ruhsat :
                    </Label>
                    <Uploader onInfoChange={this.handleInfoChange_}
                              fileName={this.state.fileInfo.ruhsatnameFileName} file={this.props.memberInfo.ruhsatnameFile} isDisabled={false}/>
                    <br/>
                    <Label className="col-sm-3" >
                        Diploma :
                    </Label>
                    <Uploader onInfoChange={this.handleInfoChange_}
                              fileName={this.state.fileInfo.diplomaFileName} file={this.props.memberInfo.diplomaFile} isDisabled={false}/>
                    <br/>
                    <Label className="col-sm-3" >
                        İkametgah :
                    </Label>
                    <Uploader onInfoChange={this.handleInfoChange_}
                              fileName={this.state.fileInfo.ikametgahFileName} file={this.props.memberInfo.ikametgahFile} isDisabled={false}/>
                </Form>
            </div>
        );
    }
}

export default FileUpload;




// WEBPACK FOOTER //
// ./src/page/fileUpload/FileUpload.js